import React from "react";

export function Logo({ variant = "dark", className = "", width = 180 }) {
  const src = variant === "light" ? "/logo-myfleet-white.png" : "/logo-myfleet.png";
  return (
    <img
      src={src}
      alt="My Fleet"
      className={className}
      style={{ width, height: "auto", display: "block", userSelect: "none" }}
      data-testid="app-logo"
    />
  );
}
